import axios from "axios";
import { config } from "../config/config";
import Cookies from "js-cookie";

const axiosInstance = axios.create({
  baseURL: config.base.url,
  timeout: 5000,
  withCredentials: true,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] =
      config.headers["Content-Type"] || "multipart/form-data";
    const token = Cookies.get("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.status === false) {
      handleUnauthorized();
      return Promise.reject(new Error("Operation failed"));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

const handleUnauthorized = () => {
  Cookies.remove("authToken", {
    domain: config.domain,
    path: "/",
    secure: config.ENVIRONMENT === "prod",
    sameSite: "Strict",
  });

  if (typeof window !== "undefined") {
    setTimeout(() => {
      window.location.href = "/";
    }, 100);
  }
};

export default axiosInstance;
